import type { FinanceStatus } from '@/types/database';

/**
 * Client-side mirror of the `finance_entries_with_status` view logic.
 *
 * A paid/canceled entry keeps its stored status. Otherwise an entry whose
 * `due_date` is strictly before today is `overdue`; everything else is
 * `pending`. Dates are plain 'YYYY-MM-DD' strings (DATE columns, no timezone)
 * so we compare them lexicographically against a 'YYYY-MM-DD' "today" — string
 * comparison is correct for zero-padded ISO dates and dodges timezone drift.
 */
export function computeFinanceStatus(
  status: FinanceStatus | string | null | undefined,
  dueDate: string | null | undefined,
  today: string = todayIsoDate(),
): FinanceStatus {
  if (status === 'paid' || status === 'canceled') {
    return status;
  }
  if (dueDate && dueDate < today) {
    return 'overdue';
  }
  return 'pending';
}

/** Local calendar date as 'YYYY-MM-DD' (no UTC conversion). */
export function todayIsoDate(date: Date = new Date()): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
